import React from 'react'

function AlertBorradoExit({cerrar}) {
  return (
    <div className='w-50' style={{alignItems:'center' , margin:'auto'}}>
    <div class="alert alert-success  alert-dismissible fade show ">
        <strong>Atencion!</strong> Los datos se han borrado con exito. &nbsp;&nbsp;

        <button type="button" class="btn-close"
          onClick={cerrar} data-bs-dismiss="alert"></button>
    </div>
</div>
  )
}

export default AlertBorradoExit